import React from 'react';

import { LEARN_MORE_MISSING_DESTINATION_LABEL, READINESS_ISSUE_LABEL } from '../constants';
import { CandidateReadinessIssue, DigestEditionCandidate } from '../types';

const issueLabel = (issue: CandidateReadinessIssue, candidate: DigestEditionCandidate): string =>
  issue === 'missing_cta_destination' && candidate.render_slot === 'learn_more'
    ? LEARN_MORE_MISSING_DESTINATION_LABEL
    : READINESS_ISSUE_LABEL[issue];

const CandidateReadinessIssues: React.FC<{ candidate: DigestEditionCandidate }> = ({
  candidate,
}) => {
  const issues = candidate.readiness_issues ?? [];
  if (issues.length === 0) {
    return null;
  }
  return (
    <ul className="flex flex-wrap gap-1.5">
      {issues.map((issue) => (
        <li
          key={issue}
          className="px-2 py-0.5 text-xs font-medium text-amber-800 bg-amber-50 border border-amber-200 rounded-full"
        >
          {issueLabel(issue, candidate)}
        </li>
      ))}
    </ul>
  );
};

export default CandidateReadinessIssues;
